// Unified text design tokens — Professional Light Theme
export const TC = {
  primary:      "#1e293b",
  secondary:    "#475569",
  tertiary:     "#94a3b8",
  midtone:      "#334155",
  white:        "#ffffff",
  link:         "#2563eb",
  linkHover:    "#1d4ed8",
  error:        "#dc2626",
  warning:      "#d97706",
  warningAmber: "#f59e0b",
  success:      "#059669",
  successAlt:   "#10b981",
  info:         "#2563eb",
  teal:         "#0d9488",
  purple:       "#7c3aed",
  amber:        "#f59e0b",
  grey:         "#64748b",
};

export const FS = {
  xs:   "0.7rem",
  sm:   "0.78rem",
  md:   "0.875rem",
  base: "0.938rem",
  lg:   "1.063rem",
  xl:   "1.25rem",
};

export const FW = {
  normal:   400,
  medium:   500,
  semibold: 600,
  bold:     700,
};

